<template>
<div class="chapter">
<div class="inner_page">
<div id="x02_Neal_pt1.html" xml:lang="en-US">
<div class="Opener">
<p class="Part-Part-Num-1">Part One</p>
<p class="Part-Title-1">Mogul Style</p>
<p class="Bibliography-7">
</p></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Neal_pt1.vue?c0438ea0